'use client';
import { JumboCard, JumboScrollbar } from 'themes/jumbo/@jumbo/components';
import {
  Chip,
  Typography,
  Button,
  Tooltip
} from '@mui/material';
import { IssuesList } from './components';
import { useSelector } from 'react-redux';
import { FoldersActions } from "actions";
import { useHistory } from 'react-router-dom';
import { getFileIcon } from "actions/GlobalActions";
import { trackEvent } from "components/Tracking";
import { useState, useEffect } from "react";
import _ from 'utils/@lodash';

const IssuesCard = ({title, filter}:{title:React.ReactNode, filter:string}) => {
	const data = useSelector((state: any) => state.cache.data);
  const entities = data.entities;
  const projects = data.projects;
  const issuesData: any[] = [];
  const _list = [...Object.entries(entities)]
  const history = useHistory();
  const handleClick = (e: any) => {
    trackEvent("Dashboard", "Issues", "Btn_All");
    history.push(`/issues`);
  };

  const storeAuthData = useSelector((state: any) => state.auth);
  const { defaultProjects } = storeAuthData;
  //const demoProjectsHidden = Number(localStorage.getItem('hideDemoProjects') || 0) > 0;

  const [list, setList] = useState<any[]>(_list);

  useEffect(() => {
    const data = _list
                    .filter((item: any) => !defaultProjects.includes(item[0]))
                    .filter((item: any) => filter !== 'all' ? item[0] === filter : item[0] !== null);
    !_.isEqual(data, list) && setList(data);
  }, [_list, list, defaultProjects, filter])

  list.map((entry: any, index: number) => {
    const id = entry[0];
    const issues: any = Object.values(entry[1]).filter((p: any) => {
      return p.state === 'ERROR' && p.name;
    });
    if (!projects[id] || issues.length < 1) return;
    issues.map((p: any, index: number) => {
      if(!p) return;
      const workflow = FoldersActions.getWorkflowFromEntity(p);
      
      issuesData.push({
        projectID: id,
        projectName: projects[id].name,
        path: FoldersActions.getPathFromEntity(p),
        workflow,
        products: (workflow?.products || []).join(" - "),
        errorInfo: p.error_info ? atob(p.error_info) : 'Unknown Error',
        date: p.file_date,
        fileName: getFileIcon(p),
        name: p.name,
      })
    })

  });

  const CardTitle = () => (
    <div style={{display: "flex", justifyContent: 'space-between'}}>
      <div style={{display: "flex", gap: '10px', alignItems: 'center'}}>
        <Typography color={'text.primary'} variant={'h6'} mb={0}>
          {title}
        </Typography>
        <Chip
          size={'small'}
          label={issuesData.length}
          color='success'
          sx={{
            textAlign: 'center',
            backgroundColor: '#868484ff',
            transform: 'scale(.8)'
          }}
        />
      </div>
      { issuesData.length > 0 && (
        <Tooltip title="All issues" placement="top" arrow>
          <Button
            size={'small'}
            variant={'outlined'}
            onClick={handleClick} 
            style={{height: '25px', minWidth: 'auto'}}
          >
            All
          </Button>
        </Tooltip>
      )}
    </div>
  )

  return (
    <JumboCard
      title={<CardTitle />}
      contentWrapper
      contentSx={issuesData.length > 0 ? { p: 0, minHeight: '75%'} : { p: 0, minHeight: '75%', alignItems: 'center', display: 'flex', width: '100%', justifyContent: 'center'}}
      sx={{height: '325px'}}
    >
      <IssuesList issuesList={issuesData} />
    </JumboCard>
  );
};

export { IssuesCard };
